const fr = {
  onboarding: {
    countryQuestion: "Compris ! 🌍\n\nDans quel pays êtes-vous ?",
    countryPlaceholder: "Dans quel pays êtes-vous ?",
    letsGo: "C'est parti !",
    summaryIntro: "🎉 Super, {name} ! Tout est prêt !",
    yourNameLabel: "votre nom",
    baseLanguageLabel: "langue de base",
    goalsHint: "Vous pouvez ajuster votre objectif de vocabulaire et la durée du cours à tout moment depuis la page Objectifs.",
    startLearning: "Commencer à apprendre le {destLang} !",
  },
  header: {
    learner: "Apprenant",
    home: "🏠 Accueil",
    allLessons: "📚 Toutes les leçons",
    currentLesson: "📖 Leçon en cours",
    flashcards: "🃏 Flashcards",
    progress: "📈 Progression",
    goals: "🎯 Objectifs",
    grammarLab: "📘 Grammaire",
    more: "⋯ Plus",
    myVocabulary: "📝 Mon Vocabulaire",
    listenSpeak: "🎧 Écouter et Parler",
    signOut: "↩ Déconnexion",
  },
  lab: {
    title: "Labo Écouter et Parler",
    back: "Retour",
    intro: "Ayez une courte conversation orale avec Babi sur un sujet que vous avez déjà étudié.",
    pickTopic: "Choisissez un sujet que vous avez terminé",
    noTopics: "Terminez d'abord une leçon, puis revenez ici pour vous entraîner à parler.",
    level: "Niveau {level}",
    talkAbout: "Parlez à Babi de « {topic} »",
    speedLabel: "Vitesse de Babi",
    speedNormal: "Normale",
    speedSlow: "Lente",
    speedNote: "La vitesse lente utilise plus de vos minutes vocales pour la même réponse.",
    startConversation: "Démarrer la conversation",
    tapToStart: "Appuyez sur le micro et répondez à Babi en turc.",
    continueConversation: "Répondre à la question",
    finishSession: "Terminer",
    voiceReviewHint: "Vérifiez ce que vous avez dit, puis confirmez — ou recommencez.",
    voiceConfirm: "Confirmer",
    voiceRedo: "Recommencer",
    voiceDenied: "La voix n'est pas disponible sans accès au microphone. Appuyez sur l'icône du micro à tout moment pour réessayer.",
    lowBalanceWarning: "Il vous reste peu de minutes vocales pour ce cycle mensuel.",
    thinking: "Babi réfléchit…",
    complete: "Session terminée",
    completeSub: "Bel entraînement. Revenez quand vous voulez pour parler d'un autre sujet.",
    another: "Pratiquer un autre sujet",
    done: "Terminé",
    replyError: "Babi n'a pas pu répondre pour le moment. Veuillez réessayer dans un instant.",
    tryAgain: "Réessayer",
    eliteUpsellTitle: "Écouter et Parler est une fonctionnalité Elite",
    eliteUpsellBody: "Vous êtes sur le forfait Pro. Passez à Elite dans les Réglages pour vous entraîner à parler avec Babi.",
    listenAgainButton: "Réécouter",
    listenAgainPlaying: "Arrêter",
    translateButton: "Traduire",
    translating: "Traduction…",
    translateFailed: "Traduction impossible — réessayez.",
    starsAriaLabel: "{stars} sur 3",
    explainButton: "Expliquer plus",
    explaining: "Explication en cours…",
    explainFailed: "Impossible d'obtenir une explication — réessayez.",
    recapHeading: "Rapport de conversation",
    recapTitle: "Votre récapitulatif",
    recapAvgStars: "Moyenne de cette session",
    recapTurnsCompleted: "{completed} tour(s) sur {total} terminé(s)",
    recapErrorFree: "{n} tours sans erreur",
    recapMistakesByType: "Erreurs par type",
    recapCorrections: "Ce qui a été corrigé",
    voiceMinutesTitle: "Minutes vocales",
    voiceMinutesLeft: "{amount} sur {total} restantes ce cycle",
    voiceMinutesNone: "Plus de minutes mensuelles ce cycle",
  },
  dashboard: {
    greeting: "Bonjour, {name} ! 👋",
    streakMsg: "Série de {streak} jours 🔥 — continuez !",
    noStreak: "Commencez votre première leçon aujourd'hui !",
    streakProtectionDays: "{n} Jours de Protection de Série gagnés 🛡️",
    dayInfo: "Langue de base : {lang} · Jour {day} sur {total}",
    dayStreak: "jours de suite",
    share: "Partager",
    wordsLearned: "Mots appris",
    lessonsDone: "Leçons terminées",
    goalComplete: "Objectif atteint",
    timeStudied: "Temps d'étude",
    hoursUnit: "Heures",
    paceTitle: "📊 Suivi de rythme quotidien",
    statusAhead: "🚀 {delta} mots d'avance !",
    statusBehind: "⚡ {delta} mots à rattraper",
    statusOnTrack: "✅ Exactement dans les temps !",
    paceTarget: "Objectif : {wpd} mots/jour · Aujourd'hui : {today} mots",
    paceExpected: "Attendu : {n}",
    paceGoal: "Objectif : {n}",
    actionCurrentLesson: "Leçon en cours",
    actionAllLessons: "Toutes les leçons",
    actionFlashcards: "Flashcards",
    actionProgress: "Ma progression",
    actionGoals: "Mes objectifs",
    actionMyVocabulary: "Mon Vocabulaire",
    actionGrammarLab: "Laboratoire de Grammaire",
    actionListenSpeak: "Labo Écouter et Parler",
    lessonsSub: "{count} thèmes · {words} mots",
    cardsDue: "{n} cartes à revoir !",
    allCaughtUp: "Tout est à jour ! 🎉",
    progressSub: "Graphiques, précision, croissance du vocabulaire",
    myVocabSub: "Parcourez tous les mots que vous avez appris",
    listenSpeakSub: "Entraînez-vous à parler avec Babi",
    goalsSub: "{words} mots · {days} jours",
    apiCost: "💰 Suivi des coûts API",
    since: "depuis {date}",
    resetBtn: "↺ Réinitialiser",
    totalTokens: "total tokens",
    inputTokens: "entrée",
    outputTokens: "sortie",
    estCost: "coût est.",
    apiNote: "claude-sonnet-5 · $3/MTok in · $15/MTok out",
    tipLabel: "Conseil :",
    tips: [
      "En turc, le verbe vient toujours en fin de phrase — «Ben kahve içiyorum» signifie «Moi café je-bois.» Absorbez simplement les structures !",
      "Le turc utilise l'harmonie vocalique — les suffixes adaptent leurs voyelles à la dernière voyelle du radical (ex. -lar/-ler, -da/-de). Une fois repérée, tout s'enchaîne !",
      "Le turc n'a pas de genre grammatical. Pas de noms masculins ou féminins — une chose de moins à mémoriser par rapport au français ou à l'espagnol !",
      "Les pronoms personnels (ben = je, sen = tu) sont généralement omis car le suffixe verbal indique déjà le sujet.",
      "Le turc est phonétiquement régulier — chaque lettre se prononce toujours de la même façon. On prononce exactement ce qu'on lit.",
      "La négation se forme en ajoutant -me/-ma directement après le radical verbal : gel (viens) → gelme (ne viens pas), anla (comprends) → anlama.",
      "Le turc utilise des postpositions qui viennent APRÈS le nom : «İstanbul'da» = «à Istanbul» (Istanbul + suffixe locatif -da).",
      "Le suffixe du pluriel suit l'harmonie vocalique : -lar après les voyelles postérieures (a, ı, o, u) et -ler après les voyelles antérieures (e, i, ö, ü).",
      "Le suffixe -ıyor/-iyor/-uyor/-üyor marque le présent progressif. Anlıyorum = je comprends (anla + ıyor + um).",
      "Les verbes composés turcs associent un nom à etmek (faire) ou olmak (être) : teşekkür etmek (remercier), hazır olmak (être prêt).",
    ],
  },
  lesson: {
    backBtn: "← Retour",
    topicOf: "Thème {order} sur {total} · {words} mots",
    translating: "Préparation de la leçon…",
    newWords: "✨ Nouveaux mots ({n})",
    alreadyLearned: "🔄 Déjà appris ({n})",
    practiceDialogue: "🎭 Pratique",
    generateDialogue: "🎭 Donne-moi un dialogue de pratique",
    listenSpeakPractice: "🎧 S'entraîner dans le Labo Écouter et Parler",
    generatingDialogue: "Babi prépare votre dialogue…",
    newDialogue: "↺ Nouveau dialogue",
    lessonSaved: "🎉 Leçon sauvegardée ! Ajout de {n} nouvelles flashcards…",
    alreadyTaken: "✅ Leçon déjà complétée",
    markComplete: "✅ Marquer la leçon comme terminée & sauvegarder",
  },
  vocab: {
    structure: "Structure",
    loadingExample: "Chargement…",
    limitReached: "↺ Limite atteinte",
    anotherLeft: "↺ Un autre ({n} restant)",
    anotherExample: "↺ Autre exemple",
    analyzing: "Analyse…",
    analyzed: "✓ Analysé",
    analyzeWord: "🔍 Analyser le mot",
    analysisIntro: "Voici l'analyse grammaticale étape par étape :",
    analysisError: "Impossible de charger l'analyse. Réessayez.",
    reportMistake: "🚩 Signaler une erreur",
    reportWrongMeaning: "Mauvaise signification du mot",
    reportWrongSentence: "Mauvaise signification de la phrase",
    reportOther: "Autre",
    reportChecking: "Vérification…",
    reportThanks: "✓ Merci de nous aider à nous améliorer !",
    reportNoIssue: [
      "Je n'ai trouvé aucun problème ici — cela me semble correct !",
      "Je ne vois aucun problème ici — cela semble correct.",
      "Tout me paraît en ordre.",
      "Je n'ai identifié aucun problème ; cela semble correct tel qu'écrit.",
      "Cela me semble bien — je n'ai aucune inquiétude.",
      "J'ai vérifié et je n'ai rien trouvé à modifier.",
      "Aucun problème ne m'a semblé évident ; la traduction paraît correcte.",
      "D'après ce que je peux voir, tout est correct.",
      "Je n'ai pas réussi à repérer de problème ; cela me semble correct.",
    ],
    reportCheckError: "J'ai eu du mal à terminer la vérification. Veuillez réessayer plus tard.",
    reportOkBtn: "OK, j'ai compris",
    reportEscalateBtn: "Transmettre à un relecteur humain",
    reportEscalatedMsg: "✓ Envoyé à notre équipe de relecture. Merci !",
    reportAlreadyFlaggedMsg: "✓ Ceci a déjà été signalé à notre équipe de relecture. Merci !",
  },
  allLessons: {
    title: "📚 Toutes les leçons",
    subtitle: "{count} thèmes · {words} mots",
    searchPlaceholder: "🔍 Rechercher thèmes ou mots…",
    noResults: "Aucun thème ne correspond à \"{search}\"",
    overwhelmedBanner: "Vous avez {n} cartes à revoir. Veuillez réviser vos flashcards avant de commencer de nouvelles leçons.",
    overwhelmedLock: "Révisez les flashcards d'abord",
    overwhelmedBtn: "Aller aux flashcards →",
  },
  flashcards: {
    title: "Flashcards",
    cardOf: "Carte {current} sur {total}",
    tapToReveal: "Tapez pour révéler",
    hearIt: "🔊 Écouter",
    hearSentence: "🔊 Écouter la phrase.",
    allConsolidated: "Tout est consolidé",
    noDue: "Aucune carte à revoir maintenant.\nVotre mémoire est bien reposée.",
    backToDashboard: "Retour au tableau de bord",
    sessionComplete: "Session terminée",
    memoryRetention: "Efficacité de la mémoire",
    forgotten: "Oublié",
    struggled: "Difficile",
    recalled: "Rappelé",
    effortless: "Facile",
    wordsConsolidated: "{retained} sur {total} mots consolidés",
    wordsInProgress: "{retained} sur {total} mots en cours",
    saveContinue: "Sauvegarder & continuer",
    tomorrow: "Demain",
    nDays: "{n} jours",
    d1Title: "Compréhension",
    d1SubSkill: "Pour améliorer les compétences de lecture et d'écoute",
    d1Journey: "Les nouveaux mots commencent leur voyage ici.",
    d1Due: "{n} à réviser",
    d1Listen: "Écouter",
    d1ShowWord: "Afficher le mot",
    d2Title: "Production",
    d2SubSkill: "Pour améliorer les compétences d'expression orale et écrite",
    d2WillStart: "Démarrera plus tard",
    d2Empty: "Les mots arrivent ici une fois maîtrisés dans le jeu de compréhension.",
    d2ModalTitle: "Entraînement à la production débloqué !",
    d2ModalBody: "Ce sont des mots que vous reconnaissez déjà bien. Maintenant nous vous entraînons à les produire — c'est ainsi que vous passez de la compréhension du {targetLang} à sa pratique.",
    d2ModalBtn: "Compris",
    leaveConfirmTitle: "Progression de révision non enregistrée",
    leaveConfirmBody: "Vous avez révisé des cartes dans cette session qui n'ont pas encore été enregistrées. Si vous partez maintenant sans enregistrer, cette progression sera perdue.",
    leaveConfirmSave: "Enregistrer et quitter",
    leaveConfirmDiscard: "Ignorer et quitter",
    leaveConfirmCancel: "Annuler",
    faq: {
      whyTwoQ: "Pourquoi deux jeux ?",
      whyLaterQ: "Pourquoi le jeu de production commence-t-il plus tard ?",
      whyReturnQ: "Pourquoi les cartes reviennent-elles ?",
    },
  },
  grammarLab: {
    title: "📘 Laboratoire de Grammaire",
    subtitle: "{count} points de grammaire à explorer",
    backBtn: "← Retour",
    searchPlaceholder: "🔍 Rechercher un point de grammaire…",
    noResults: "Aucun point de grammaire ne correspond à \"{search}\"",
    allCategories: "Toutes les catégories",
    allLevels: "Tous les niveaux",
    notReviewedLabel: "Non consulté",
    reviewedLabel: "Consulté",
    dueBadge: "{n} à réviser",
    explanationLabel: "Explication",
    seeReference: "(voir {term})",
    ruleLabel: "Règle",
    formsLabel: "Formes",
    translatingNote: "Traduction en français en cours...",
    practiceBtn: "▶ S'entraîner sur ce point",
    detailedExplanationBtn: "📖 Explication détaillée",
    practiceTitle: "Entraînement",
    practiceQuestion: "Comment dit-on cela en turc ?",
    practiceOf: "{current} sur {total}",
    practiceCorrectFeedback: "Correct !",
    practiceIncorrectFeedback: "Pas tout à fait — la réponse était {answer}.",
    practiceNext: "Suivant →",
    practiceDone: "Entraînement terminé",
    practiceScore: "{correct} sur {total} correctes",
    practiceNextReview: "Prochaine révision dans {days} jour{plural}",
    practiceReset: "Pas cette fois — tu reverras ce point demain.",
    practiceAgainBtn: "S'entraîner à nouveau",
    practiceCloseBtn: "Terminé",
    categories: {
      existential: "Existence",
      noun_suffix: "Suffixe Nominal",
      case_suffix: "Suffixe de Cas",
      verb_conjugation: "Conjugaison Verbale",
      question_particle: "Particule Interrogative",
      copula: "Copule",
      modal_construction: "Construction Modale",
      adjectives: "Adjectifs",
      case: "Cas",
      modality: "Modalité",
      mood: "Mode",
      morphology: "Morphologie",
      morphophonology: "Morphophonologie",
      phonology: "Phonologie",
      pronouns: "Pronoms",
      register: "Registre",
      syntax: "Syntaxe",
      tense: "Temps Verbal",
      voice: "Voix",
    },
    points: {
      GP0001: { title: "Existence et Disponibilité : var / yok", ruleSummary: "[lieu/possesseur] + [chose] + var / yok" },
      GP0002: { title: "Suffixe du Pluriel : -ler / -lar", ruleSummary: "nom + -ler (antérieur) / -lar (postérieur)" },
      GP0003: { title: "Cas Locatif : -de / -da / -te / -ta", ruleSummary: "nom + -de/-da ; -te/-ta après consonne sourde" },
      GP0004: { title: "Cas Datif : -e / -a", ruleSummary: "nom + -e/-a ; insertion d'un -y- tampon après une voyelle" },
      GP0005: { title: "Cas Ablatif : -den / -dan / -ten / -tan", ruleSummary: "nom + -den/-dan ; -ten/-tan après consonne sourde" },
      GP0006: { title: "Cas Accusatif : -i / -ı / -u / -ü (objet direct défini)", ruleSummary: "nom + -i/-ı/-u/-ü ; -y- tampon après une voyelle" },
      GP0007: { title: "Présent Progressif — Affirmatif : -iyor", ruleSummary: "radical verbal + -iyor + terminaison personnelle" },
      GP0008: { title: "Présent Progressif — Négatif : -mıyor / -miyor / -muyor / -müyor", ruleSummary: "radical verbal + -mıyor/-miyor/-muyor/-müyor + terminaison personnelle" },
      GP0009: { title: "Présent Progressif — Interrogatif : -iyor mu", ruleSummary: "radical + -iyor + mu(+personnelle) ; onlar : radical + -iyorlar + mı" },
      GP0010: { title: "Particule Interrogative Oui/Non : mı / mi / mu / mü", ruleSummary: "[mot] + particule séparée mı/mi/mu/mü ?" },
      GP0011: { title: "Passé Simple (Défini) : -di / -dı / -du / -dü / -ti / -tı / -tu / -tü", ruleSummary: "radical verbal + -di/-dı/-du/-dü (ou -ti/... après sourde) + terminaison personnelle" },
      GP0012: { title: "Terminaisons du Verbe 'Être' (Présent) : -(y)ım, -sin, -ø, -(y)ız, -siniz", ruleSummary: "prédicat + -(y)ım / -sin / -ø / -(y)ız / -siniz / (-lar)" },
      GP0013: { title: "Suffixes Possessifs : mon / ton / son / notre / votre / leur", ruleSummary: "(benim/senin/...) nom + -im/-in/-i/-imiz/-iniz/-leri" },
      GP0014: { title: "Exprimer le Désir : -mek / -mak istemek", ruleSummary: "[infinitif -mek/-mak] + istemek (conjugué)" },
      GP0015: { title: "Requête Polie / Impératif 2e Personne du Pluriel : -in / -iniz", ruleSummary: "radical verbal + -in/-ın/-un/-ün (poli) ou -iniz (plus formel) ; -y- tampon après une voyelle" },
      GP0016: { title: "Adoucissement Consonantique (Dévoisement) : p/ç/t/k → b/c/d/ğ", ruleSummary: "[mot se terminant par p/ç/t/k, si adoucissement lexical] + suffixe commençant par une voyelle → b/c/d/ğ remplace la consonne finale" },
      GP0017: { title: "Radicaux Verbaux Irréguliers : gitmek, etmek, yemek, demek", ruleSummary: "git-→gid-, et-→ed-, ye-→yi-, de-→di- devant un suffixe commençant par une voyelle" },
      GP0018: { title: "Radicaux à Chute Vocalique avant -iyor", ruleSummary: "[radical verbal se terminant par -e/-a atone] + -iyor → la voyelle finale tombe, puis -iyor s'attache" },
      GP0019: { title: "Les Voyelles Turques", ruleSummary: "8 voyelles : a, e, ı, i, o, ö, u, ü — chacune est antérieure/postérieure ET non arrondie/arrondie" },
      GP0020: { title: "Harmonie Vocalique", ruleSummary: "La voyelle du suffixe correspond à la dernière voyelle du mot : radical antérieur → voyelle de suffixe antérieure, radical postérieur → voyelle de suffixe postérieure (et arrondie/non arrondie pour les suffixes à 4 voies)" },
      GP0021: { title: "Cas Génitif : -in/-ın/-un/-ün", ruleSummary: "[nom] + in/ın/un/ün (harmonie à 4 voies ; -n- tampon si le nom se termine par une voyelle)" },
      GP0022: { title: "Déterminants Possessifs (benim, senin, onun...)", ruleSummary: "Pronom personnel + suffixe génitif : ben→benim, sen→senin, o→onun, biz→bizim, siz→sizin, onlar→onların" },
      GP0023: { title: "Futur : -ecek/-acak", ruleSummary: "[radical] + (y) + ecek/acak (k→ğ devant une terminaison personnelle commençant par une voyelle) + personne" },
      GP0024: { title: "Passé Rapporté (Évidentiel) : -miş", ruleSummary: "[radical] + mış/miş/muş/müş (harmonie à 4 voies) + terminaison personnelle prédicative" },
      GP0025: { title: "Passé Progressif : -iyordu", ruleSummary: "[radical en forme -iyor] + du/dun/duk/dunuz (+ -lar s'ajoute avant -dı pour la 3e pl.)" },
      GP0026: { title: "Capacité : -ebilmek/-abilmek (« pouvoir ») - affirmatif", ruleSummary: "[radical] + (y)e/(y)a + bil + ir (toujours -ir, exception fixe propre à l'aoriste de bilmek) + personne" },
      GP0027: { title: "Ordre des Mots", ruleSummary: "Par défaut : Sujet - Objet/Lieu - Verbe (le verbe est en dernier). Flexible pour l'emphase ; le rôle est marqué par les suffixes de cas, non par la position." },
      GP0028: { title: "Conjonctions", ruleSummary: "ve (et), ama (mais), çünkü (parce que), veya (ou) - mots invariables, sans conjugaison de suffixe" },
      GP0029: { title: "Postpositions (Prépositions)", ruleSummary: "ile (avec), için (pour), gibi (comme), kadar (jusqu'à/autant que), önce (avant), sonra (après) - suivent toutes le nom" },
      GP0030: { title: "Comparatif et Superlatif", ruleSummary: "daha + adjectif (comparatif) ; en + adjectif (superlatif) ; [nom-ablatif] daha [adjectif] = « plus ADJ que nom »" },
      GP0031: { title: "Adverbes Turcs (fréquence/degré)", ruleSummary: "çok (très/beaucoup), az (un peu), hiç (jamais/pas du tout - utilisé avec un verbe négatif), bazen (parfois), şimdi (maintenant)" },
      GP0032: { title: "Aoriste (Présent Simple / Habituel) : -er/-ir/-ar/-ır", ruleSummary: "Polysyllabique : [radical]+ir/ır/ur/ür (terminé par une consonne, régulier) ou [radical]+r (terminé par une voyelle, régulier). Monosyllabique terminé par une consonne : DIVISÉ LEXICALEMENT entre -Ar et -Ir - vérifier verbe par verbe, ne pas deviner." },
      GP0033: { title: "Passé Habituel : -erdi/-ırdı (« avait l'habitude de »)", ruleSummary: "[radical de l'aoriste] + di/dı/du/dü (4 voies, selon la propre voyelle de -ir/-ar) + personne" },
      GP0034: { title: "Futur dans le Passé : -ecekti/-acaktı (« allait »)", ruleSummary: "[radical du futur] + ti (assourdi, singulier/1re pl.) OU + ler + di (voisé, 3e pl., pas d'assourdissement car -ler se termine par 'r')" },
      GP0035: { title: "Conditionnel Irréel : -se/-sa (radical nu)", ruleSummary: "[radical] + se/sa (2 voies) + personne (m, n, -, k, niz, ler)" },
      GP0036: { title: "Nécessité : -malı/-meli (« devoir »)", ruleSummary: "[radical] + malı/meli (2 voies) + (y) + terminaison personnelle prédicative" },
      GP0037: { title: "Participe Sujet : -en/-an (« celui qui... »)", ruleSummary: "[radical] + en/an (2 voies) ; les radicaux terminés par une voyelle prennent un -y- tampon" },
      GP0038: { title: "Proposition Temporelle : -ince/-ınca (« quand... »)", ruleSummary: "[radical terminé par une consonne] + ince/ınca (2 voies, schéma confirmé) ; le schéma pour les radicaux terminés par une voyelle N'EST PAS ENCORE VÉRIFIÉ" },
      GP0039: { title: "Comparaison des Temps du Passé", ruleSummary: "-di (constaté) vs -miş (rapporté) vs -iyordu (était en train de faire) vs -irdi (avait l'habitude de faire)" },
      GP0040: { title: "Formes de Cas des Pronoms Démonstratifs : bu/şu/o", ruleSummary: "bu/şu/o + n (tampon) + suffixe de cas" },
      GP0041: { title: "Démonstratifs de Lieu : bura/şura/ora (« ici/là »)", ruleSummary: "bura/şura/ora + suffixe de cas (-y- tampon seulement avant le datif)" },
      GP0042: { title: "Mots Interrogatifs", ruleSummary: "ne, kim, nerede, nasıl, kaç, ne zaman, neden - tous invariables" },
      GP0043: { title: "Cas Instrumental : -(y)le/-(y)la (« avec / au moyen de »)", ruleSummary: "[nom] + (y)le/(y)la (harmonie à 2 voies ; -y- tampon si terminé par une voyelle)" },
      GP0044: { title: "Suffixes Adjectivaux « Avec/Sans » : -lı/-siz", ruleSummary: "[nom] + lı/li/lu/lü (« avec ») ou sız/siz/suz/süz (« sans ») - harmonie à 4 voies" },
      GP0045: { title: "Incapacité : -(y)AmA- (« ne pas pouvoir »)", ruleSummary: "[radical] + (y)e/(y)a + me/ma + terminaison personnelle de l'aoriste négatif (m/mez-sin/mez/meyiz/mez-siniz/mez-ler)" },
      GP0046: { title: "Conditionnel Réel : [radical de l'aoriste] + -se/-sa (« si X se produit »)", ruleSummary: "[radical de l'aoriste] + se/sa (2 voies, selon la propre voyelle du suffixe de l'aoriste) + personne" },
      GP0047: { title: "Participe Objet : -DIk + possessif (« que [sujet] a verbé »)", ruleSummary: "[radical] + DIk (4 voies ; s'adoucit en ğ seulement devant un possessif commençant par une voyelle) + possessif" },
      GP0048: { title: "Usage du Participe Futur (réutilise les formes du futur)", ruleSummary: "Mêmes formes de surface que le futur (see GP0023), utilisées adjectivalement devant un nom au lieu d'un verbe conjugué" },
      GP0049: { title: "Propositions Temporelles : -DIğI zaman / -mADIğI zaman / -DIktan sonra", ruleSummary: "[participe objet] + zaman = « quand » ; [-DIk nu] + ten + sonra = « après »" },
      GP0050: { title: "Le Suffixe -ki (relativiseur)", ruleSummary: "[nom locatif / pronom génitif] + ki (INVARIABLE - pas d'harmonie)" },
      GP0051: { title: "Durée : -DAn beri / -DIr (« depuis » — point de départ ou durée)", ruleSummary: "[temps]+den beri = « depuis X » (point de départ) ; [durée]+dir/dır/dur/dür + présent = « depuis X » (durée écoulée, toujours en cours)" },
      GP0052: { title: "Voix Passive : -Il/-In", ruleSummary: "terminé par une consonne (pas l) : +Il/ıl/ul/ül ; terminé par l : +In/ın/un/ün ; terminé par une voyelle : +n" },
      GP0053: { title: "Causatif : -t/-DIr/-Ir (liste sélectionnée seulement - lexicalement complexe)", ruleSummary: "Allomorphe déterminé lexicalement - vérifier chaque verbe individuellement, ne pas généraliser" },
      GP0054: { title: "Réfléchi : -In/-ın (« faire X à soi-même »)", ruleSummary: "[radical] + In/ın/un/ün (ou n après voyelle) - sens réfléchi, déterminé lexicalement comme le passif (see GP0052)" },
      GP0055: { title: "Réciproque : -Iş/-ış (« se faire X l'un à l'autre »)", ruleSummary: "[radical] + Iş/ış/uş/üş (4 voies) - action mutuelle/conjointe" },
      GP0056: { title: "Optatif (Que je / Allons) : -(y)eyim/-(y)elim", ruleSummary: "[radical] + (y)eyim (1re sg.) / (y)elim (1re pl.) - harmonie à 2 voies" },
      GP0057: { title: "Registre Narratif : -mış Répété (art du récit)", ruleSummary: "-mış est utilisé de façon répétée tout au long d'un récit, pas une seule fois, pour maintenir le registre narratif" },
      GP0058: { title: "« Ne kadar da » (intensificateur - « comme... ! »)", ruleSummary: "Ne kadar da + [adjectif] = intensificateur exclamatif" },
      GP0059: { title: "Converbe de Manière : -ArAk (« en faisant X »)", ruleSummary: "[radical] + arak/erek (harmonie à 2 voies)" },
      GP0060: { title: "Converbe Séquentiel : -Ip (« et, ayant fait X »)", ruleSummary: "[radical] + Ip/ıp/up/üp (4 voies) - seul le dernier verbe de la chaîne porte un temps" },
      GP0061: { title: "Proposition Causale : -DIğI için (« parce que X [s'est produit] »)", ruleSummary: "[participe objet] (see GP0047) + için (see GP0029) = « parce que X »" },
      GP0062: { title: "« Diye » (« en pensant/disant que... »)", ruleSummary: "[proposition] + diye + [proposition principale] = « en pensant/pour la raison que [proposition], [proposition principale] »" },
      GP0063: { title: "« Olarak » (« en tant que X »)", ruleSummary: "[nom] + olarak = « en tant que [nom] »" },
      GP0064: { title: "« Tarafından » (Marqueur d'Agent Passif - « par X »)", ruleSummary: "[groupe nominal] + tarafından + [verbe passif] (see GP0052)" },
      GP0065: { title: "« Rağmen » (« malgré »)", ruleSummary: "[nom + datif] (see GP0004) + rağmen = « malgré X »" },
      GP0066: { title: "« Göre » (« selon »)", ruleSummary: "[nom/pronom + datif] + göre = « selon X »" },
      GP0067: { title: "Verbes Semi-Modaux + Complément au Datif", ruleSummary: "[nom/verbe-mA] + datif + alışmak/başlamak/çalışmak/karar vermek/izin vermek/benzemek/inanmak/üzülmek" },
      GP0068: { title: "Expressions Épistémiques et Évidentielles", ruleSummary: "gibi geliyor = « on dirait » (see GP0029) (see GP0007) ; -mış olmalı = « doit avoir » (see GP0024) (see GP0036) ; -mış görünmek = « semble avoir » ; bildiğim kadarıyla = « pour autant que je sache » (see GP0047) (see GP0029) (see GP0043)" },
      GP0069: { title: "Verbes Courants + Objet à l'Accusatif : unutmak, sormak, hatırlamak", ruleSummary: "[nom + accusatif] (see GP0006) + unutmak/sormak/hatırlamak" },
      GP0070: { title: "Konuşmak vs. Söylemek (« parler » vs. « dire »)", ruleSummary: "konuşmak = l'acte de parler (langue/personne) ; söylemek = dire [une chose précise], objet à l'accusatif" },
    },
  },
  placementTest: {
    title: "🎯 Test de niveau",
    offerTitle: "Vous connaissez déjà un peu de turc ?",
    offerBody: "Passez un test de niveau rapide — environ 20 questions — pour trouver votre point de départ. Nous ajusterons votre Leçon actuelle en conséquence, mais tous les sujets restent accessibles à la consultation.",
    startBtn: "Commencer le test",
    notNowBtn: "Pas maintenant",
    roundLabel: "Manche {round} sur {totalRounds}",
    questionLabel: "Question {n} sur {total}",
    notSureOption: "Je ne suis pas sûr(e)",
    notSureHint: "(Sélectionnez la cinquième option si vous n'êtes pas sûr(e) à 100 %.)",
    wordPrompt: "Que signifie ce mot ?",
    listeningPrompt: "Écoutez et sélectionnez le mot que vous entendez",
    listeningReplay: "Réécouter",
    preparingRound: "Préparation de vos questions…",
    finishBtn: "Voir mon résultat",
    resultsTitle: "Votre résultat de niveau",
    resultsLevel: "Vous êtes placé(e) au niveau {level}",
    resultsBody: "Votre Leçon actuelle commence maintenant à ce niveau. Vous pouvez toujours consulter n'importe quel sujet antérieur ou ultérieur depuis Toutes les leçons.",
    continueBtn: "Continuer",
  },
  goals: {
    title: "🎯 Mes objectifs",
    displayName: "Nom d'affichage",
    namePlaceholder: "Votre nom…",
    vocabTarget: "Objectif de vocabulaire",
    words: "mots",
    minWords: "1 500 min",
    midWords: "2 000",
    maxWords: "3 500 max",
    courseDuration: "Durée de cours cible",
    months: "Mois",
    month: "mois",
    monthsPlural: "mois",
    daysSummary: "= {days} jours",
    baseLanguage: "Langue de base",
    otherLanguage: "Autres langues (bientôt disponible)",
    selectLanguage: "Sélectionnez une langue…",
    ok: "OK",
    langNames: {
      English: "Anglais", Farsi: "Persan", Arabic: "Arabe",
      French: "Français", German: "Allemand", Spanish: "Espagnol",
      Russian: "Russe", Portuguese: "Portugais", Chinese: "Chinois",
      Turkish: "Turc", Hindi: "Hindi", Italian: "Italien",
    },
    targetLanguage: "Langue cible",
    targetLangNames: {
      Turkish: "Turc",
    },
    wordsLbl: "mots",
    wordsPerDay: "mots/jour",
    daysLbl: "jours",
    saved: "✅ Objectifs sauvegardés !",
  },
  progress: {
    title: "📈 Ma progression",
    memDistTitle: "Distribution des états mémoriels · {n} cartes",
    inAcquisition: "En acquisition",
    rooted: "Ancré",
    fluent: "Fluide",
    deeplyRetained: "Profondément retenu",
    acqDesc: "< 3j de stabilité",
    rootedDesc: "3 – 21j de stabilité",
    fluentDesc: "21 – 90j de stabilité",
    retainedDesc: "90j+ de stabilité",
    forecastTitle: "Prévision de révision — 15 prochains jours",
    cardsDue: "Cartes à revoir",
    today: "Auj.",
    tmrw: "Dem.",
    plusDays: "+{n}j",
    todayFull: "Aujourd'hui",
    tmrwFull: "Demain",
    plusDaysFull: "+{n} jours",
    goalProgress: "Progression globale",
    wordsLearned: "{learned} / {target} mots appris",
    vocabGrowth: "Croissance du vocabulaire",
    noChart: "Terminez votre première leçon pour voir le graphique ! 📚",
    wordsLearnedSeries: "Mots appris",
    topicRings: "Anneaux de mémoire par thème",
    quickStats: "Stats rapides",
    dayStreak: "jours de suite 🔥",
    lessonsDone: "leçons terminées",
    totalStudy: "étude totale",
    avg14Day: "moyenne 14j",
    minUnit: "min",
    dayLabel: "Jour {n}",
    cards: "cartes",
  },
  myVocab: {
    title: "📝 Mon Vocabulaire",
    summaryTitle: "{n} mots rencontrés",
    searchPlaceholder: "🔍 Rechercher vos mots…",
    allStatuses: "Tous les statuts",
    noResults: "Aucun mot ne correspond à \"{search}\"",
    noWords: "Terminez une leçon pour commencer à construire votre vocabulaire ! 📚",
    completedTopicsTitle: "Sujets terminés ({n} sur {total})",
    noDate: "—",
  },
  badges: {
    newbie: "Bleu",
    wordExplorer: "Explorateur de Mots",
    wordNerd: "Geek des Mots",
    wordWizard: "Magicien des Mots",
    rockstar: "Rockstar",
    expert: "Expert",
    champion: "Champion",
  },
  memStates: {
    inAcquisition: "En acquisition",
    rooted: "Ancré",
    fluent: "Fluide",
    deeplyRetained: "Profondément retenu",
  },
  chat: {
    subtitle: "Votre tuteur de turc",
    greetWords: ["Salut", "Bonjour", "Coucou"],
    greeting: "{greet} {name},\n\nPosez-moi toutes vos questions sur le turc — grammaire, vocabulaire, culture — ou sur l'utilisation de cette application.",
    placeholder: "Question sur le turc ou l'appli…",
    error: "Désolé, je n'ai pas pu me connecter. Veuillez réessayer.",
    escalationFallback: "Désolé, je n'ai pas pu vous aider complètement avec cela. J'ai transmis cela à notre équipe, et vous recevrez une réponse par e-mail — généralement sous 2 jours ouvrés. Vous pouvez également nous contacter directement à support@speafy.com.",
    welcome: "Bonjour, {name} ! 👋 Bienvenue sur Speafy ! Je suis Babi, et je suis là pour deux choses : vous aider à découvrir l'application, et répondre à toutes vos questions sur {targetLanguage}.\n\nCommencez par la leçon en cours, ou choisissez un sujet dans «Toutes les leçons». N'oubliez pas de marquer chaque leçon comme terminée lorsque vous avez fini, puis de revoir les Flashcards ensuite.\n\nDemandez-moi n'importe quand — à propos de l'application ou de {targetLanguage}.\n\nBonne chance dans votre parcours d'apprentissage ! 😊",
    lessonLimit: "Tu as déjà complété {limit} leçons aujourd'hui — bravo ! 🌟\n\nPour que ton apprentissage reste durable et éviter de surcharger ta file de flashcards, il y a une limite de {limit} leçons par jour.\n\nLaisse ton cerveau consolider ce que tu as appris aujourd'hui. Que dirais-tu d'une session de révision des flashcards à la place ?\n\nJe serai là demain pour la suite ! 😊",
    streakDecayed: "Content de te revoir ! 👋 Tu étais absent {days} jour(s). Grâce aux {protection} Jours de Protection de Série 🛡️ que tu avais gagnés, ta série n'a baissé que de {oldStreak} à {newStreak} au lieu de disparaître complètement. Continuons à construire !",
    streakWiped: "Content de te revoir ! 👋 Tu étais absent {days} jour(s) — plus que les {protection} Jours de Protection de Série 🛡️ que tu avais accumulés, donc ta série est repartie à 1. Toute série commence quelque part — reconstruisons-la !",
    weeklyRecapFallback: "Salut ! 👋 Je voulais te donner ton récap hebdomadaire, mais j'ai du mal à le préparer en ce moment. Petit point rapide quand même — tu es sur une série de {streak} jour(s), continue comme ça ! 🔥",
    dailyPlanQuestion1: "Salut ! 👋 Combien de temps as-tu pour étudier aujourd'hui ?",
    dailyPlanQuestion2: "Coucou ! 😊 J'ai un plan d'étude pour toi — combien de minutes peux-tu consacrer aujourd'hui ?",
    dailyPlanQuestion3: "Prêt·e pour le plan du jour ? 🎯 Dis-moi juste à peu près combien de temps tu as.",
    dailyPlanClarify: "Désolé, je n'ai pas bien compris ! Peux-tu me donner un chiffre approximatif, comme '20' ou '30 minutes' ?",
    dailyPlanUnreasonable: "Ça ne ressemble pas vraiment à une session d'étude classique ! Peux-tu me donner un chiffre entre 5 minutes et environ 5 heures ?",
    dailyPlanGiveUp: "Pas de souci — dès que tu es prêt·e, va simplement sur Flashcards ou ta Leçon en cours et lance-toi ! 😊",
    dailyPlanFallback: "J'ai bien noté ton temps disponible, mais j'ai du mal à préparer le plan du jour en ce moment. En attendant, les Flashcards sont toujours une bonne option si tu as des cartes à réviser ! 😊",
    sendBtn: "Envoyer",
    askBabi: "Demander à Babi",
    voiceConsentTitle: "Activer le chat vocal avec Babi ?",
    voiceConsentBody: "Babi utilisera votre microphone pour vous écouter et votre haut-parleur pour vous répondre. Votre voix est convertie en texte — l'enregistrement audio lui-même n'est jamais conservé. Le texte peut être conservé jusqu'à 30 jours. Consultez notre Politique de confidentialité pour plus de détails.",
    voiceConsentPrivacyLink: "Politique de confidentialité",
    voiceConsentAllow: "Autoriser le microphone",
    voiceConsentDecline: "Pas maintenant",
    voiceDenied: "Le chat vocal n'est pas disponible sans accès au microphone. Vous pouvez continuer à discuter en tapant — appuyez sur l'icône du micro à tout moment pour réessayer.",
    voiceDeviceInUse: "Votre microphone semble être utilisé ailleurs — fermez les autres applications qui l'utilisent et réessayez.",
    voiceError: "Un problème est survenu avec le chat vocal. Veuillez réessayer.",
    voiceStarting: "Démarrage… veuillez patienter",
    voiceListening: "J'écoute…",
    voiceProcessing: "Je comprends…",
    voiceReviewHint: "Appuyez pour modifier, sinon ceci sera envoyé automatiquement dans quelques secondes.",
    voiceSendNow: "Envoyer maintenant",
    voiceDiscard: "Ignorer",
    voiceEditTranscript: "Modifier ce que Babi a entendu",
    voiceBadgeLabel: "Envoyé par la voix",
    voiceDidntCatch: "Je n'ai pas compris — appuyez sur le micro pour réessayer.",
    voiceSpeaking: "Babi parle…",
    voiceTtsUnavailable: "L'audio n'était pas disponible pour cette réponse — affichage du texte à la place.",
    voiceTtsUnavailableLanguage: "La réponse vocale de Babi n'est pas encore disponible en {language}.",
    voiceTapToHear: "Appuyez pour entendre la réponse de Babi",
    voiceNotEntitled: "Le chat vocal avec Babi est une fonctionnalité premium — passez à un forfait supérieur pour l'utiliser.",
    voiceNoBalance: "Vous avez utilisé toutes vos minutes vocales pour ce cycle. Elles seront renouvelées au prochain cycle.",
    voiceOtherTabActive: "Le chat vocal est déjà actif dans un autre onglet.",
    voiceLowBalanceNudge: "Il vous reste peu de minutes vocales pour ce cycle.",
    voiceLowMinutesHeadsUp: "Il vous reste peu de minutes vocales pour ce cycle.",
    voiceGetMoreMinutes: "Obtenir plus de minutes",
    voiceStopBtn: "Arrêter",
    voiceMicButtonLabel: "Chat vocal",
    voiceBannerDismiss: "Ignorer",
  },
  settings: {
    title: "Paramètres",
    accountSection: "Compte",
    linkedGoogle: "Lié avec Google",
    emailAccountBadge: "Compte e-mail",
    changeNameBtn: "Changer le nom d'utilisateur",
    nameSaveBtn: "Enregistrer",
    nameCancelBtn: "Annuler",
    nameSaving: "Enregistrement…",
    passwordLabel: "Mot de passe",
    passwordSub: "Envoyer un lien de réinitialisation à votre e-mail",
    passwordSent: "Envoyé ✓",
    passwordResetBtn: "Réinitialiser",
    subscriptionSection: "Abonnement",
    subscriptionAdminLabel: "Compte administrateur",
    subscriptionAdminSub: "Vous disposez d'un accès complet et permanent à toutes les fonctionnalités.",
    subscriptionReviewerLabel: "Accès testeur",
    subscriptionReviewerSub: "Vous avez un accès gratuit à toutes les fonctionnalités en tant que testeur de l'application.",
    subscriptionProPlan: "Speafy Pro — {plan}",
    subscriptionElitePlan: "Speafy Elite — {plan}",
    subscriptionPlanAnnual: "Annuel",
    subscriptionPlanMonthly: "Mensuel",
    subscriptionRenews: "Se renouvelle le {date}",
    subscriptionActive: "Actif",
    subscriptionManageLink: "Facturation et factures",
    subscriptionCancelLink: "Annuler ou suspendre l'abonnement",
    subscriptionPaymentFailedLabel: "Votre dernier paiement a échoué",
    subscriptionPaymentFailedSub: "Paiement échoué le {date}",
    subscriptionPaymentFailedSubNoDate: "Veuillez mettre à jour votre moyen de paiement pour conserver l'accès Pro",
    subscriptionUpdatePaymentLink: "Mettre à jour le moyen de paiement ↗",
    subscriptionCancelledPending: "Votre abonnement se termine le {date} — vous conserverez l'accès Pro jusque-là",
    subscriptionPausedLabel: "Abonnement en pause",
    subscriptionPausedSub: "Reprend automatiquement le {date} — vous serez facturé(e) en totalité pour une nouvelle période sauf si vous reprenez plus tôt",
    subscriptionPausedSubNoDate: "Reprend automatiquement après 3 mois sauf si vous reprenez plus tôt",
    subscriptionResumeBtn: "Reprendre maintenant",
    subscriptionResuming: "Reprise en cours…",
    pausePendingLabel: "Pause programmée",
    pausePendingSub: "Prend effet le {date}, à la fin de votre période de facturation actuelle",
    manageOfferTitle: "Vous pensez à annuler ?",
    manageOfferSub: "Mettez en pause à la place — vous conservez votre progression jusqu'au {date}, puis l'abonnement reprendra automatiquement et vous serez facturé(e) en totalité pour une nouvelle période après 3 mois, sauf si vous reprenez plus tôt.",
    manageOfferPauseBtn: "Mettre en pause à la place",
    manageOfferContinueLink: "Annuler quand même",
    manageOfferDismiss: "Laisser tomber",
    pauseOfferLabel: "Besoin d'une pause ?",
    pauseOfferSub: "Mettez votre abonnement en pause pendant 3 mois au lieu de l'annuler — gardez votre progression, reprenez à tout moment.",
    pauseOfferBtn: "Mettre en pause",
    pauseConfirmP1: "Mettre votre abonnement Speafy Pro en pause ?",
    pauseConfirmC1: "Votre période de facturation actuelle continue jusqu'au {date} — vous conservez tout ce que vous avez déjà payé.",
    pauseConfirmC2: "Pendant la pause, les nouvelles Leçons sont verrouillées (comme un plan gratuit expiré), mais vous pouvez toujours réviser vos Cartes existantes normalement.",
    pauseConfirmC3: "La pause dure 3 mois fixes. Si vous ne reprenez pas manuellement avant, votre abonnement reprendra automatiquement et vous serez facturé(e) en totalité pour une nouvelle période.",
    pauseConfirmBtn: "Confirmer la pause",
    pausing: "Mise en pause…",
    pauseFailedGeneric: "Une erreur s'est produite lors de la mise en pause de votre abonnement. Veuillez réessayer ou contacter le support.",
    manageLinkLoading: "Chargement…",
    manageLinkFailedGeneric: "Impossible de charger un lien de gestion pour le moment. Veuillez réessayer.",
    resumeConfirmP1: "Reprendre votre abonnement Speafy Pro maintenant ?",
    resumeConfirmC1: "Vous serez facturé(e) en totalité pour une nouvelle période de facturation immédiatement.",
    resumeConfirmBtn: "Oui, reprendre maintenant",
    resumeFailedGeneric: "Une erreur s'est produite lors de la reprise de votre abonnement. Veuillez réessayer ou contacter le support.",
    subscriptionLastCharge: "Dernier prélèvement : {amount} le {date} — {status}",
    subscriptionLastChargePaid: "Payé",
    subscriptionLastChargeFailed: "Échoué",
    tierChangePendingLabel: "Changement de forfait programmé",
    tierChangePendingToElite: "Passage à Elite le {date}",
    tierChangePendingToBasic: "Passage à Pro le {date}, à la fin de votre période de facturation actuelle",
    tierUpgradeToEliteLink: "Passer à Elite",
    tierDowngradeToBasicLink: "Revenir à Pro",
    tierUpgradeConfirmTitle: "Passer à Elite ?",
    tierUpgradeConfirmSub: "La différence au prorata vous sera facturée aujourd'hui, et vous obtiendrez immédiatement les 3 heures de conversation vocale d'Elite avec Babi — {price}/{interval} ensuite.",
    tierDowngradeConfirmTitle: "Revenir à Pro ?",
    tierDowngradeConfirmSub: "Vous garderez Elite jusqu'au {date}, puis passerez à Pro à votre prochaine date de facturation — aucun frais aujourd'hui.",
    tierUpgradeConfirmBtn: "Oui, passer à Elite",
    tierDowngradeConfirmBtn: "Oui, revenir à Pro",
    tierChangeBusy: "Mise à jour…",
    tierChangeFailedGeneric: "Un problème est survenu lors du changement de forfait. Veuillez réessayer ou contacter le support.",
    voiceMinutesLabel: "Minutes vocales ({tier})",
    voiceTierElite: "Elite",
    voiceTierBasic: "Pro",
    voiceTierTrial: "Essai",
    voiceTierAdmin: "Admin",
    voiceTierViewer: "Observateur",
    voiceMinutesUsed: "{used} utilisées sur {limit} ce cycle",
    voiceMinutesPurchasedExtra: "Plus {extra} achetées — utilisées une fois vos minutes mensuelles épuisées, et n'expirent jamais",
    yourDataSection: "Vos Données",
    marketingLabel: "Consentement aux Communications Marketing",
    marketingSub: "Mises à jour, notifications et offres spéciales",
    voiceConsentLabel: "Chat Vocal avec Babi",
    voiceConsentSub: "Autoriser Babi à vous entendre et à répondre à voix haute",
    privacyLegalSection: "Confidentialité, Conditions & Mentions Légales",
    privacyPolicyLabel: "Politique de Confidentialité",
    privacyPolicySub: "Comment nous collectons, utilisons et protégeons vos données",
    viewLink: "Voir",
    termsLabel: "Conditions d'Utilisation",
    termsSub: "Règles et conditions régissant votre utilisation",
    refundLabel: "Politique de Remboursement",
    refundSub: "Admissibilité et démarche pour demander un remboursement",
    cookieSettingsLabel: "Paramètres des Cookies",
    cookieSettingsSub: "Gérer les cookies analytiques et fonctionnels",
    manageLink: "Gérer",
    privacySection: "Confidentialité et données",
    exportLabel: "Exporter mes données",
    exportSub: "Télécharger un fichier JSON de votre profil, progression et flashcards",
    exportBtn: "Exporter",
    exportDone: "✓ Téléchargé",
    cacheLabel: "Cache local",
    cacheSub: "La progression d'apprentissage et les phrases d'exemple sont mises en cache dans votre navigateur pour la vitesse.",
    cookieLabel: "Paramètres de cookies et confidentialité",
    cookieSub: "Les préférences d'analyse et de cookies sont gérées sur le site Speafy",
    privacyLink: "Politique de confidentialité ↗",
    aboutSection: "À propos",
    aiTutorLabel: "Tuteur IA",
    aiTutorSub: "Propulsé par Claude Sonnet — Anthropic",
    algoLabel: "Algorithme de mémoire",
    algoSub: "FSRS v4.5 — Planificateur de répétition espacée",
    learningSection: "Apprentissage",
    placementTestLabel: "Test de niveau",
    placementTestSubNew: "Trouvez votre niveau de départ avec un test rapide",
    placementTestSubRetake: "Dernier niveau : {level} · à refaire quand vous voulez",
    placementTestBtnNew: "Passer le test",
    placementTestBtnRetake: "Repasser le test",
    versionLabel: "Version",
    appearanceSection: "Apparence",
    darkModeLabel: "Mode sombre",
    darkModeSub: "Passer à un schéma de couleurs sombre",
    largeTextLabel: "Grand texte",
    largeTextSub: "Augmente la taille du texte pour une lecture plus facile",
    babiCheckinsSection: "Points de contact Babi",
    babiDailyNudgeLabel: "Le rappel quotidien de Babi",
    babiDailyNudgeSub: "Babi te demande combien de temps tu as et te propose un plan d'étude chaque jour",
    babiWeeklyReportLabel: "Le rapport hebdomadaire de Babi",
    babiWeeklyReportSub: "Un récap hebdomadaire de tes progrès, une fois par semaine",
    dangerSection: "Zone de danger",
    resetLabel: "Réinitialiser tous les progrès",
    resetSub: "Efface votre série, vos flashcards et l'historique des leçons. Irréversible.",
    resetBtn: "Réinitialiser",
    resetConfirmP1: "Réinitialiser tous les progrès ? Cela supprimera définitivement :",
    resetConfirmC1: "Toutes les {n} flashcards et leurs données de mémoire",
    resetConfirmC2: "Votre série ({n} jours) et historique d'étude",
    resetConfirmC3: "Tous les enregistrements de leçons terminées, dans toutes les langues que vous apprenez",
    resetConfirmC4: "Vos progrès de révision dans le Laboratoire de Grammaire",
    resetConfirmP2: "Votre compte, nom et paramètres de langue seront conservés.",
    resetConfirmBtn: "Oui, tout réinitialiser",
    resetting: "Réinitialisation…",
    resetDone: "✅ Progrès réinitialisés ! Vous repartez à zéro.",
    deleteLabel: "Supprimer le compte",
    deleteSub: "Supprime définitivement votre compte et toutes vos données. Irréversible.",
    deleteBtn: "Supprimer le compte",
    deleteConfirmP1: "Supprimer définitivement votre compte Speafy ? Cela supprimera immédiatement et irréversiblement :",
    deleteConfirmC1: "Votre profil (nom, langue, objectifs)",
    deleteConfirmC2: "Toutes les {n} flashcards et données de mémoire",
    deleteConfirmC3: "Votre historique d'apprentissage complet et votre série",
    deleteConfirmC4: "Votre compte d'authentification Firebase",
    deleteConfirmPrompt: "Tapez DELETE (en majuscules) pour confirmer :",
    deleteConfirmBtn: "Supprimer définitivement mon compte",
    deleting: "Suppression…",
    cancelBtn: "Annuler",
  },
  trial: {
    daysLeftBadge: "⏱ {n} jours restants",
    expiredBadge: "Essai terminé · Améliorer ↑",
    pausedBadge: "⏸ En pause",
    proBadge: "✦ Plan Pro",
    eliteBadge: "✦ Plan Elite",
  },
  paywall: {
    back: "← Retour",
    title: "Passer à Speafy Pro",
    subTrialExpired: "Votre période d'essai est terminée. Passez à la version supérieure pour continuer.",
    subDefault: "Débloquez toutes les leçons et la révision de fiches.",
    features: [
      "Toutes les {count} leçons entièrement débloquées",
      "Chat illimité avec Babi, votre tuteur IA",
      "Révision intelligente FSRS",
      "Suivi des progrès et analyses mémoire",
      "Audio natif pour chaque mot",
      "Dialogues d'entraînement",
      "Interface multilingue",
    ],
    tierPro: "Pro",
    tierElite: "Elite",
    eliteFeatures: [
      "Tout ce qui est inclus dans Speafy Pro",
      "Labo Écouter et Parler — pratique de conversation guidée avec Babi",
      "3 heures de conversation vocale avec Babi chaque mois",
      "Achetez des minutes vocales supplémentaires à tout moment — 3 $/heure",
    ],
    billingMonthly: "Mensuel",
    billingYearly: "Annuel",
    saveBadge: "Économisez 25%",
    pricePerMonth: "/mois",
    priceBilledYearly: "facturé annuellement",
    cta: "Commencer Speafy Pro →",
    ctaElite: "Commencer Speafy Elite →",
    fine: "Annulez à tout moment · Paiement sécurisé via Paddle",
    bannerExpired: "Votre essai gratuit est terminé.",
    bannerActive: "Essai gratuit — {n} jours restants.",
    bannerBtn: "Améliorer ↑",
    settingsFreePlan: "Plan Gratuit",
    pausedTitle: "Votre abonnement est en pause",
    pausedSub: "Reprenez votre abonnement dans Paramètres pour déverrouiller de nouvelles leçons.",
    pausedGoToSettingsBtn: "Aller aux Paramètres",
    alreadyProTitle: "Vous êtes déjà Pro !",
    alreadyProSub: "Votre abonnement est actif — pas besoin de racheter.",
    alreadyProGoHomeBtn: "Aller à l'accueil",
    settingsTrialRemaining: "Essai — {n} jours restants",
    settingsTrialEnded: "Essai terminé — passez à la version supérieure pour débloquer tout",
    settingsFreeForever: "Reprenez là où vous en étiez — passez à la version supérieure pour débloquer toutes les leçons",
    settingsUpgradeBtn: "Améliorer",
  },
  authAction: {
    verifyingTitle: "Vérification de votre e-mail…",
    verifiedTitle: "Votre e-mail est vérifié !",
    verifiedBody: "Tout est prêt. Continuez sur Speafy pour poursuivre votre apprentissage.",
    continueBtn: "Continuer vers Speafy →",
    verifyErrorTitle: "Ce lien a expiré",
    verifyErrorBody: "Ce lien de vérification n'est plus valide. Connectez-vous et nous vous en enverrons un nouveau.",
    resendBtn: "Renvoyer l'e-mail de vérification",
    resendSent: "Envoyé ✓",
    resendError: "Impossible de renvoyer l'e-mail. Veuillez réessayer dans un instant.",
    signInBtn: "Se connecter",
    verifyingReset: "Vérification de votre lien…",
    resetTitle: "Réinitialisez votre mot de passe",
    resetBodyFor: "Choisissez un nouveau mot de passe pour {email}",
    newPasswordPh: "Nouveau mot de passe",
    confirmPasswordPh: "Confirmez le nouveau mot de passe",
    resetSubmitBtn: "Réinitialiser le mot de passe",
    resettingBtn: "Réinitialisation…",
    resetSuccessTitle: "Mot de passe mis à jour !",
    resetSuccessBody: "Votre mot de passe a été changé. Connectez-vous avec votre nouveau mot de passe.",
    resetErrorTitle: "Ce lien a expiré",
    resetErrorBody: "Ce lien de réinitialisation n'est plus valide. Demandez-en un nouveau depuis l'écran de connexion.",
    passwordMismatch: "Les mots de passe ne correspondent pas.",
    passwordTooShort: "Le mot de passe doit contenir au moins 6 caractères.",
    genericError: "Une erreur s'est produite. Veuillez réessayer.",
    invalidTitle: "Ce lien est invalide ou a expiré",
    invalidBody: "Le lien que vous avez suivi n'est plus valide. Veuillez retourner sur Speafy et réessayer.",
    backToSignIn: "Retour à la connexion",
  },

  // Teacher-partner affiliate disclosure — FINALIZED wording, do not edit/re-translate.
  // `reviewed: false` → a native speaker flips it to `true` after confirming. See strings.js.
  affiliate: {
    disclosure: {
      text: "Petite précision : si tu t'abonnes à Speafy via mon lien, je touche une petite commission — cela ne te coûte rien de plus.",
      reviewed: false,
    },
    // Promo message — FINALIZED + native-verified. `{{referral_link}}` is a literal placeholder. See strings.js.
    promoTemplate: {
      text: "Salut à tous ! Je voulais vous recommander une application qui est un excellent complément à nos cours : Speafy. Elle suit exactement les thèmes qu'on étudie ensemble, et vous pouvez pratiquer l'expression orale à tout moment avec une partenaire de conversation basée sur l'IA, nommée Babi. C'est gratuit pour commencer, et je recevrai un rapport hebdomadaire sur vos progrès, afin de voir comment vous vous en sortez entre nos séances. Inscrivez-vous via ce lien pour être rattachés à moi en tant que professeur : {{referral_link}}",
      reviewed: true,
    },
  },

  teacherDash: {
    link: "Espace enseignant",
    title: "Espace enseignant",
    backHome: "Retour à l'accueil",
    studentBadge: "Ton prof : {name}",
    intro: "Tout ce qu'il vous faut pour amener vos élèves sur Speafy et suivre leurs progrès.",
    referralTitle: "Votre lien de parrainage",
    referralBody: "Partagez ce lien avec vos élèves. Toute personne qui s'inscrit via ce lien vous est rattachée en tant qu'enseignant.",
    copy: "Copier le lien",
    copied: "Copié",
    shareText: "Rejoins-moi sur Speafy et apprenons une langue ensemble ! {link}",
    shareTelegramText: "Rejoins-moi sur Speafy et apprenons une langue ensemble !",
    shareEmailSubject: "Rejoins-moi sur Speafy",
    shareWhatsapp: "WhatsApp",
    shareTelegram: "Telegram",
    shareEmail: "E-mail",
    shareSms: "SMS",
    shareMore: "Plus",
    studentsTitle: "Vos élèves",
    studentsLoading: "Chargement de vos élèves…",
    studentsError: "Impossible de charger vos élèves pour le moment.",
    retry: "Réessayer",
    studentsEmpty: "Aucun élève pour l'instant. Partagez votre lien de parrainage — les élèves qui s'inscrivent via ce lien apparaîtront ici.",
    colName: "Élève",
    colJoined: "Inscrit le",
    colStatus: "Abonnement",
    colCommission: "Commission gagnée",
    colGrammar: "Points de grammaire",
    statusActive: "Actif",
    statusTrial: "Essai",
    statusNone: "Pas d'abonnement",
    commissionNote: "Voici ce que vous avez gagné au total pour chaque élève. Votre solde disponible pour un paiement est indiqué ci-dessous.",
    commissionCapReached: "Période de 12 mois terminée",
    grammarNote: "Les données sur les erreurs de grammaire ne sont affichées que pour les étudiants ayant un abonnement actif.",
    studentUnnamed: "Élève",
    curriculumTitle: "Référentiel du programme",
    curriculumBody: "Parcourez tous les thèmes et mots que vos élèves apprennent, dans l'ordre.",
    curriculumLink: "Ouvrir le référentiel du programme",
    profileTitle: "Votre profil d'enseignant",
    profileBody: "Voici comment vous apparaîtrez dans l'annuaire des enseignants Speafy à son lancement.",
    profileBio: "Courte présentation",
    profileBioPh: "Une ou deux phrases sur vous et votre façon d'enseigner.",
    profilePhoto: "Photo",
    photoChoose: "Choisir une photo",
    photoUploading: "Envoi…",
    photoRemove: "Retirer",
    photoHint: "PNG ou JPG, jusqu'à 200 Ko.",
    photoTypeErr: "Choisissez une image PNG ou JPG.",
    photoSizeErr: "Cette image dépasse 200 Ko — choisissez-en une plus petite.",
    photoUploadErr: "Échec de l'envoi. Veuillez réessayer.",
    profileLink: "Site web personnel ou lien vers un réseau social",
    profileLinkPh: "www.exemple.com",
    profileLanguages: "Langues que j'enseigne",
    profileLanguagesHint: "Choisissez les langues que vous enseignez. D'autres s'activeront à mesure que Speafy les ajoutera comme langues de cours.",
    profileLanguagesSoon: "Bientôt disponible",
    save: "Enregistrer",
    saving: "Enregistrement…",
    saved: "Enregistré",
    urlError: "Cela ne ressemble pas à une adresse web. Vérifiez-la ou laissez le champ vide.",
    termsStatusAccepted: "Conditions du partenariat enseignant — Acceptées le {date}",
    termsStatusPending: "Conditions du partenariat enseignant — Pas encore acceptées",
    termsVersionLabel: "Version {version}",
    termsView: "Voir les Conditions acceptées",
    payoutTitle: "Paiement",
    payoutLoading: "Chargement de votre statut de paiement…",
    payoutError: "Nous n'avons pas pu charger votre statut de paiement pour le moment.",
    payoutBalance: "Votre solde actuel : {balance}",
    payoutNotEligible: "Vous pourrez demander un paiement une fois votre solde atteint {threshold}.",
    payoutAlreadyRequested: "Paiement demandé — nous vous recontacterons.",
    requestPayoutBtn: "Demander un paiement",
    payoutRequestFailed: "Une erreur s'est produite lors de l'envoi de votre demande. Veuillez réessayer.",
    payoutConfirmTitle: "Demander un paiement ?",
    payoutConfirmBody: "Vous avez actuellement {balance} disponibles à demander.\n\nCela lance un processus de paiement manuel — aucun argent n'est transféré automatiquement. Nous examinerons votre demande et vous recontacterons par e-mail.",
    payoutConfirmBtn: "Demander un paiement",
    payoutConfirmCancel: "Annuler",
  },

  teacherTerms: {
    screenTitle: "Conditions du partenariat enseignant",
    contents: "Sommaire",
    lastUpdatedLabel: "Dernière mise à jour",
    effectiveLabel: "Date d'entrée en vigueur",
    bannerTitle: "Action requise",
    bannerBody: "Veuillez lire et accepter les Conditions du partenariat enseignant pour rester partenaire.",
    bannerCta: "Lire et accepter",
    acceptedOn: "Vous avez accepté ces Conditions le {date}.",
    acceptedVersion: "Version acceptée : {version}",
    accepting: "Enregistrement de votre acceptation…",
    acceptError: "Nous n'avons pas pu enregistrer votre acceptation pour le moment. Veuillez réessayer.",
    draftNotice: "Ces Conditions ne sont pas encore définitives. Vous pourrez les accepter une fois la date d'entrée en vigueur fixée.",
  },
};

export default fr;
